<template>
  <footer class="footer">
    <div class="footer__top w-95">
      <div>
        <h2 class="title --small">{{ $beet.options.footer.title }}</h2>
        <div class="footer__link-group">
          <FooterLink type="maps" :label="$beet.options.contact.address.label"
            :link="$beet.options.contact.address.link" />
          <div>
            <FooterLink type="phone" :label="$beet.options.contact.phone" />
            <FooterLink type="mail" :label="$beet.options.contact.email" />
          </div>
        </div>
      </div>
      <div>
        <h3 class="title --small">{{ $beet.options.footer.bus.title }}</h3>
        <div class="footer__link-list">
          <a :href="link.link" v-for="link in $beet.options.footer.bus.items" target="_blank" :key="link.flexKey">
            {{ link.label }}
          </a>
        </div>
      </div>
      <div class="footer__alerts">
        <div class="footer__fraud">
          <FaQuestion v-if="$beet.options.footer.fraud.title" :image="$beet.options.footer.fraud.icon"
            :content="{ question: $beet.options.footer.fraud.title, answer: $beet.options.footer.fraud.description }" />
        </div>
        <div class="footer__policy">
          <FaQuestion v-if="$beet.options.footer.policy.title" :image="$beet.options.footer.policy.icon"
            :content="{ question: $beet.options.footer.policy.title, answer: policyDescription }" />
        </div>
      </div>
    </div>
    <div class="footer__bottom">
      <p>{{ $beet.options.footer.credits.replace('[YEAR]', new Date().getFullYear()) }}</p>
      <p class="footer__bottom-separator">|</p>
      <nav class="footer__bottom-links">
        <template v-for="(link, linkIndex) in $beet.options.footer.links" :key="link.flexKey">
          <a :href="link.link" :title="link.label" target="_blank">
            {{ link.label }}
          </a>
          <span v-if="linkIndex < $beet.options.footer.links.length - 1">·</span>
        </template>
      </nav>
    </div>
  </footer>
</template>

<script>
import { FooterLink } from '@/components/small'
import { FaQuestion } from '@/components/cards'

export default {
  name: 'SiteFooter',
  components: { FaQuestion, FooterLink },
  computed: {
    policyDescription() {
      return this.$beet.options.footer.policy.description.replace('[EMAIL]', '<a href="mailto:recruiting@ca.crh.com">send us an email</a>')
    }
  }
}
</script>